export const CLIENT_ID =
  process.env.CLIENT_ID ||
  "Ab99-LsteQBd9UKLk8D1SrEexceGv-xBScmO5rYcxM9cn06LIkQKWrZcpJ5ooFwXrjFzKv--TFqoF3t1";
export const APP_SECRET =
  process.env.APP_SECRET ||
  "ELm7xPH9qX1GgDkmipCb9eT7fkdxD_tqfY18gTsJ8mP81WmPPXH5e0I3ypo5EEmPXP2LAO7M58R8cK9U";
